const namedColors = {
    black: '#000000',
    white: '#ffffff',
    orange: '#ffa500',
};

export const normalizeColor = (color) => {
    if (!color || typeof color !== 'string') return '';
    const trimmedColor = color.trim().toLowerCase();
    return namedColors[trimmedColor] || trimmedColor;
};

export const getReadableTextColor = (backgroundColor) => {
    const normalizedColor = normalizeColor(backgroundColor);
    const hexMatch = normalizedColor.match(/^#?([a-f\d]{3}|[a-f\d]{6})$/i);

    if (!hexMatch) return '#000000';

    let hex = hexMatch[1];
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map((char) => char + char)
            .join('');
    }

    const rgb = [0, 2, 4].map(
        (index) => parseInt(hex.slice(index, index + 2), 16) / 255
    );
    const [red, green, blue] = rgb.map((channel) =>
        channel <= 0.03928
            ? channel / 12.92
            : Math.pow((channel + 0.055) / 1.055, 2.4)
    );
    const luminance = 0.2126 * red + 0.7152 * green + 0.0722 * blue;

    return luminance > 0.45 ? '#000000' : '#ffffff';
};
